export const uxConsts = {
  SHOW_PROGRESS: "SHOW_PROGRESS",
  HIDE_PROGRESS: "HIDE_PROGRESS",
  SHOW_TOASTER: "SHOW_TOASTER",
  HIDE_TOASTER: "HIDE_TOASTER"
};

export interface UXAction {
  type: string;
  progressText: string;
  toaster: ToasterInfo;
}

export interface ToasterInfo {
  open: boolean;
  variant: "success" | "info" | "warning" | "error";
  message: string;
  vertical: "top" | "bottom";
  horizontal: "left" | "center" | "right";
}
